import axios from "axios";
import global from "./global.js"

import { getToken, setToken } from "../utils/auth.js";
// import { Message } from 'element-ui';
import store from '../store/store'
const service = axios.create({
  //	  baseURL: process.env.BASE_API, // api的base_url
  //   timeout: 5000 // request timeout
});
service.interceptors.request.use(
  config => {
  
    // Do something before request is sent
    // config.headers["Token"] = getToken(); // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers["Token"] = localStorage.getItem('commonToken')
		config.headers['Url'] = window.location.href
			config.headers["Public-Key"] = 'adb076dc324e1796319f27553cfc8d1d'
    //  config.headers["Content-Type"] = "application/json";
    // 中英文国际化切换
    // zh-CN en-US zh-TW
    config.headers['language'] = store.state.common.lang == 'en' ? 'en-US' : 
    store.state.common.lang == 'zh' ? 'zh-CN' : 'zh-TW';
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    // Promise.reject(error);
  }
);
/** 拦截器中统一处理错误提示*/
service.interceptors.response.use(
  response => { 
    // Do something with response data
    if (response.data.hasOwnProperty('success') && !response.data.success) {
      // Message({
      //   type:"error",
      //   message:response.data.message
      // })
      console.info(response.data.message)
    }
    return response;
  },
  error => {
    // Message({
    //   type:"error",
    //   message:error
    // })
    // Do something with request error
    console.log(error); // for debug
    //  Promise.reject(error);
    return { data: {message: error.toString()} };

  }
);

/* 检查http码 */
function checkStatus(response) {
  if (response.data && response.data.code == '10009' ||  response.data.code == '10019') {
    global.exitLogin();
    return
  }
  // loading
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    return response.data;
    // 不需要除了data之外的数据，直接 return response.data
  }

  // 异常状态下，把错误信息返回去
  return {
    status: response.status,
    message: (response.data && response.data.message)|| '操作过于频繁'
  };
  // return {
  //   message: "操作过于频繁，请稍后再试"
  // };
 
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.response && res.response.data && res.response.data.code == '10009' || res.response.data.code == '10019') {
    global.exitLogin();
    return
  }
  if (res.status === -404) {
    alert("-404");
  }
  // res.errorMsg != undefined 是否含有errorMsg
  if (res.hasOwnProperty("errorMsg")) {
    if (res.errorMsg == "session time out.") {
      setToken();
    } else {
    }
  }

  return res;
}

export default {
  post(url, data) {
    return service({
      method: "post",
      url,
      data
    })
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  put(url, data) {
    return service({
      method: "put",
      url,
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  postType(url, data) {
    return service({
      method: "post",
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  postForm(url, data) {
    return service({
      method: "post",
      url,
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  putForm(url, data) {
    return service({
      method: "put",
      url,
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  postTypePut(url, data) {
    return service({
      method: "put",
      url,
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  delete(url, data) {
    return service({
      method: "delete",
      url,
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        // if (url == global.ucenter) {
        //   if (data.userId == store.state.common.userId) {
        //     // 如果获取用户接口，那么重新获取token
        //     setToken(response.data.data.deKey); // ucenter接口有deKey字段，重新设置进入token重置token
        //   }
        // }
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  get(url, params) {
    return service({
      method: "get",
      url,
      params, // get 请求时带的参数
    })
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  getExport(url, params) {
    return service({
      method: "get",
      url,
      params, // get 请求时带的参数
      responseType: 'blob',
    })
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  _getExport(url, params) {
    return service({
      method: "post",
      url,
      params, // get 请求时带的参数
      responseType: 'json',
    })
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  }
};



// WEBPACK FOOTER //
// ./utils/http.js